module.exports = __webpack_public_path__ + "static/media/koryufinal2.3179e456.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/proj/koryufinal2.png
// module id = 271
// module chunks = 0